import React, { Component } from 'react';
import products from './products.json';
import Modal from '../productModals/Modal';

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false };

    this.handleShow = this.handleShow.bind(this);
    this.handleHide = this.handleHide.bind(this);
  }

  handleShow(product) {
    this.setState({ showModal: true, product });
  }

  handleHide() {
    this.setState({ showModal: false });
  }

  render() {
    return (
      <section className="bg-light" id="portfolio">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading text-uppercase">Our Products</h2>
              <h3 className="section-subheading text-muted">Classification under textile, organic and craft items. </h3>
            </div>
          </div>
          <div className="row">
            {products.map(product => (
              <div key={product.id} className="col-md-4 col-sm-6 portfolio-item">
                <a className="portfolio-link" data-toggle="modal" onClick={() => this.handleShow(product)}>
                  <div className="portfolio-hover">
                    <div className="portfolio-hover-content">
                      <i className="fa fa-plus fa-3x" />
                    </div>
                  </div>
                  <img className="img-fluid" src={product.thumb300} alt={product.title} />
                </a>
                <div className="portfolio-caption">
                  <h4>{product.title}</h4>
                  <p className="text-muted">{product.subTitle} </p>
                </div>
              </div>
            ))}

          </div>
        </div>
        {this.state.showModal ? (
          <Modal handleHide={this.handleHide} product={this.state.product}/>
        ) : null}
      </section>
    )
  }
}
export default Product;


// WEBPACK FOOTER //
// ./src/components/products/Product.js